import React from 'react';

interface TreadwellCarRegularIconProps {
  className?: string;
  styleName?: string;
}

function TreadwellCarRegularIcon(props: TreadwellCarRegularIconProps) {
  const { className } = props;

  return (
    <svg className={className} viewBox="0 0 481 158">
      <path
        className={className}
        d="M409.486 147.362c-17.614 0-31.892-14.274-31.892-31.881s14.278-31.882 31.892-31.882 31.892 14.274 31.892 31.882-14.279 31.881-31.892 31.881h0zM223.823 42.032L213.647 9.309c79.65 0 125.66 37.81 125.66 37.81l-115.484-5.086zm-101.014-.539l18.058-26.923s17.368-5.262 62.808-5.262l10.176 32.723-91.041-.539zm-20.693 105.868c-17.613 0-31.892-14.274-31.892-31.881s14.279-31.882 31.892-31.882 31.893 14.274 31.893 31.882-14.279 31.881-31.893 31.881h0zM481 70.457c-22.348-25.434-132.713-26.808-132.713-26.808S297.745 0 211.792 0C79.422 0 48.135 42.618 30.256 37.119l-.532-.162C19.536 33.897 9.283 41.53 9.283 52.165v14.199c0 5.119-1.972 9.969-5.396 13.608C1.45 82.565 0 85.929 0 89.486v3.517a37.18 37.18 0 0 0 7.564 22.477l52.834 8.304C64.263 143.291 81.468 158 102.116 158c18.292 0 33.883-11.544 39.891-27.74h1.022 226.568c6.007 16.196 21.598 27.74 39.891 27.74s33.883-11.544 39.891-27.74h.68c12.809 0 20.939-1.45 26.101-3.279 5.209-1.847 5.66-9.029.717-11.499l1.567-2.088c1.37-1.827 1.873-4.169 1.335-6.389C478.26 100.732 481 91.766 481 91.766V70.457z"
        fill="#333"
      />
    </svg>
  );
}

export default TreadwellCarRegularIcon;
